import React, { useState, useEffect } from "react";
import {
  Route,
  Switch,
  withRouter,
  Link,
  Redirect,
  useHistory,
} from "react-router-dom";
import { CloseOutlined } from "@ant-design/icons";
import {
  Layout,
  Menu,
  message,
  Drawer,
  Result,
  Dropdown,
  Space,
  ConfigProvider,
  Statistic,
} from "antd";
import { MenuOutlined, GiftOutlined, SettingOutlined } from "@ant-design/icons";
import Analyzesymbol from "./symbol/analyze/analyzesymbol";
import RcQueueAnim from "rc-queue-anim";
import Fund from "./dashboard-content/Fund";
import TradeProgram from "./dashboard-content/TradeProgram";
import TradeProgramIUX from "./dashboard-content/TradeProgramIUX";
import Swap from "./dashboard-content/Swap";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  LogoutAuth,
  updateGetBonus,
  getArchive,
  getUser,
  setModalBonus,
  getUserVerifyv2,
  getUserBookbankv2,
  getBonusCampaign,
  updateModalCampaign,
  updateModalOpenAccount,
} from "../actions";
import "../assets/css/dashboard.css";
import Bonus from "./dashboard-content/Bonus";
import Wallet from "./dashboard-content/Wallet";
import Lotback from "./dashboard-content/LotBack";
import AccountType from "./dashboard-content/AccountType";
import Chart from "../components/chart/Chart";

import Transfer from "./dashboard-content/transfer/Transfer";
import Symbol from "./dashboard-content/Symbol";
import LoyaltyRissing from "./loyalty-content/LoyalRissing1";
import styled from "styled-components";

import PageSetting from "./setting";
import VerifyBookBank from "./dashboard-content/fund/verifies/VerifyBookBank";

import Compare from "./dashboard-content/Compare";

import PartnerNoti from "../components/partner-noti";
import { partnerlist } from "../api/partner";

import { getHolidayNearby } from "../api/holiday";

import io from "socket.io-client";
import FormPartner from "./partner/FormPartner";
import CreateBonus from "./dashboard-content/Bonus/CreateBonus";

import Promotion from "./dashboard-content/Promotion";
import Analyze from "./dashboard-content/analyze";

import Notification from "../components/notification/Notification";
import { deleteTokenFCM, patchTokenFCM } from "../api/notifications";
import { requestPermission } from "../firebase";
import { CheckLanguageISO } from "../helper/countryLangISO";
import { CheckLanguageImg } from "../helper/countryLangImg";
import { getuser } from "../firebase";
import Webinar from "./dashboard-content/webinar";
import { getLiveWebinar } from "../api/webinar";
import ModalJumio from "./dashboard-content/fund/verifies/Jumio/ModalJumio";
import FooterAuthPage from "../components/footer-landing-page/FooterAuth";

import ModalCloseCampaign from "../components/campaign/ModalCloseCampaign";
import CreateAccount from "./dashboard-content/Account/CreateAccount";
import AlertOpenAccount from "./dashboard-content/Account/AlertOpenAccount";
import { Logo } from "@vt/vt-ui";
import { languageSupport } from "../constants/language";
import { getDataBannerContest } from "../api/contest";
import { checkShowPopup } from "../helper/checkShowPopup";
import Contest from "../features/dashboard/contest/pages/Contest";
import ModalContest from "../components/modal-contest/ModalContest";

const { Countdown } = Statistic;
const locale = require("react-redux-i18n").I18n;
const { Header, Sider, Content } = Layout;

const navigationList = [
  {
    path: `/${localStorage.getItem("locale")}/wallet/account/`,
    mente: `/${localStorage.getItem("locale")}/maintenance`,
    icon: "/assets/images/icons/menu/wallet.svg",
    icon_ac: "/assets/images/icons/menu/wallet-ac.svg",
    title: "account",
    name: "account",
  },
  // {
  //   path: `/${localStorage.getItem("locale")}/wallet/compare`,
  //   mente: `/${localStorage.getItem("locale")}/maintenance`,
  //   icon: "/assets/images/icons/menu/vs.svg",
  //   icon_ac: "/assets/images/icons/menu/vs-ac.svg",
  //   title: "MT5 vs MT4",
  // },
  {
    path: `/${localStorage.getItem("locale")}/wallet/transfer`,
    mente: `/${localStorage.getItem("locale")}/maintenance`,
    icon: "/assets/images/icons/menu/transfer.svg",
    icon_ac: "/assets/images/icons/menu/transfer-ac.svg",
    title: "Transfer",
    name: "transfer",
  },
  {
    path: `/${localStorage.getItem("locale")}/wallet/fund`,
    mente: `/${localStorage.getItem("locale")}/maintenance`,
    icon: "/assets/images/icons/menu/transection.svg",
    icon_ac: "/assets/images/icons/menu/transection-ac.svg",
    title: "fund",
    name: "fund",
  },
  {
    path: `/${localStorage.getItem("locale")}/wallet/promotion/lotback`,
    mente: `/${localStorage.getItem("locale")}/maintenance`,
    icon: "/assets/images/icons/menu/lotback.svg",
    icon_ac: "/assets/images/icons/menu/lotback-ac.svg",
    title: "startbonus",
    name: "promotion",
  },
  {
    path: `/${localStorage.getItem("locale")}/wallet/webinar`,
    mente: `/${localStorage.getItem("locale")}/maintenance`,
    icon: "/assets/images/icons/menu/webinar.svg",
    icon_ac: "/assets/images/icons/menu/webinar-ac.svg",
    title: "Webinar",
    name: "webinar",
  },
  // {
  //   path: `/${localStorage.getItem("locale")}/partner`,
  //   mente: `/${localStorage.getItem("locale")}/partner`,
  //   icon: "/assets/images/icons/menu/partner.svg",
  //   icon_ac: "/assets/images/icons/menu/partner-ac.svg",
  //   title: "partner",
  // },
  {
    path: `/${localStorage.getItem("locale")}/wallet/analytics/report`,
    mente: `/${localStorage.getItem("locale")}/maintenance`,
    icon: "/assets/images/icons/menu/calendar.svg",
    icon_ac: "/assets/images/icons/menu/calendar-ac.svg",
    title: "analytics",
    name: "analytics",
  },
  {
    path: `/${localStorage.getItem("locale")}/wallet/contest/new-events`,
    mente: `/${localStorage.getItem("locale")}/maintenance`,
    icon: "/assets/images/icons/menu/contest.svg",
    icon_ac: "/assets/images/icons/menu/contest-ac.svg",
    title: "Contest",
    name: "contest",
  },
  {
    path: `/${localStorage.getItem("locale")}/wallet/tradingprogram`,
    mente: `/${localStorage.getItem("locale")}/maintenance`,
    icon: "/assets/images/icons/menu/trade-program.svg",
    icon_ac: "/assets/images/icons/menu/trade-program-ac.svg",
    title: "program",
    name: "tradingprogram",
  },
  {
    path: `/${localStorage.getItem("locale")}/wallet/spread`,
    mente: `/${localStorage.getItem("locale")}/maintenance`,
    icon: "/assets/images/icons/menu/spread_ic.svg",
    icon_ac: "/assets/images/icons/menu/spread_ic-ac.svg",
    title: "spread",
    name: "spread",
  },
  // {
  //   path: `/${localStorage.getItem("locale")}/wallet/spread`,
  //   mente: `/${localStorage.getItem("locale")}/maintenance`,
  //   icon: "/assets/images/icons/menu/spread_ic.svg",
  //   icon_ac: "/assets/images/icons/menu/spread_ic-ac.svg",
  //   title: "webtrade",
  //   name: "webtrade",
  // },
  // {
  //   path: `/${localStorage.getItem("locale")}/wallet/typeaccount`,
  //   mente: `/${localStorage.getItem("locale")}/maintenance`,
  //   icon: "/assets/images/icons/menu/accountType.svg",
  //   icon_ac: "/assets/images/icons/menu/accountType-ac.svg",
  //   title: "accounttype",
  // },

  // {
  //   path: `/${localStorage.getItem("locale")}/wallet/contact`,
  //   mente: `/${localStorage.getItem("locale")}/maintenance`,
  //   icon: "/assets/images/icons/menu/contact.svg",
  //   icon_ac: "/assets/images/icons/menu/contact-ac.svg",
  //   title: "contact",
  // },
  {
    path: `/${localStorage.getItem("locale")}/wallet/setting`,
    mente: `/${localStorage.getItem("locale")}/maintenance`,
    icon: "/assets/images/icons/menu/setting.svg",
    icon_ac: "/assets/images/icons/menu/setting-ac.svg",
    title: "setting_pages",
    name: "setting",
  },
  {
    divider: true,
  },
];
const otherMenu = [
  {
    path: `/${localStorage.getItem("locale")}/wallet/tradingsoftware`,
    mente: `/${localStorage.getItem("locale")}/maintenance`,
    icon: "/assets/images/icons/menu/tradingsoftware.svg",
    icon_ac: "/assets/images/icons/menu/tradingsoftwareac.svg",
    title: "dashboardProgram.title",
    name: "tradingsoftware",
  },
  {
    path: `/${localStorage.getItem("locale")}/wallet/typeaccount`,
    mente: `/${localStorage.getItem("locale")}/maintenance`,
    icon: "/assets/images/icons/menu/account-type.svg",
    icon_ac: "/assets/images/icons/menu/account-type-ac.svg",
    title: "accounttype",
    name: "typeaccount",
  },
  {
    path: `https://iuxaffiliates.com/en/`,
    mente: `/${localStorage.getItem("locale")}/maintenance`,
    icon: "/assets/images/icons/menu/partner-m.svg",
    icon_ac: "/assets/images/icons/menu/partner-m-ac.svg",
    title: "partner",
    name: "partner",
  },
  // {
  //   path: `/${localStorage.getItem("locale")}/wallet/contact`,
  //   mente: `/${localStorage.getItem("locale")}/maintenance`,
  //   icon: "/assets/images/icons/menu/contact-m.svg",
  //   icon_ac: "/assets/images/icons/menu/contact-m-ac.svg",
  //   title: "contact",
  //   name: "contact",
  // },
];
// mobile ===

const BoxMenuItem = styled.div`
  text-align: center;
  width: 100px;
  background: ${(props) => props.Background};
  border-radius: 8px;
  color: black;
  cursor: pointer;
  padding: 12px 0;
`;

export const Dashboard2 = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isOpenCreate = useSelector((state) => state.account.modalbonus);
  const isOpenModalCloseCampaign = useSelector(
    (state) => state.account.modalClosecampaign
  );
  const isModalOpenAccount = useSelector(
    (state) => state.account.modalOpenAccount
  );
  const [broken, setBroken] = useState(false);
  const [pathname, setPathname] = useState(props.location.pathname);

  const [visibleLang, setVisibleLang] = useState(false);

  const [drawerLangMobile, setDrawerLangMobile] = useState(false);
  const [isOpenVerify, setIsOpenVerify] = useState(false);
  const [modalLang, setModalLang] = useState(
    localStorage.getItem("locale" || "en")
  );
  const windowWidthRespone = window.innerWidth;
  const [mt, setMt] = useState(false);
  const [partner, setPartner] = useState([]);
  const [holiday, setHoliday] = useState(null);
  const [visible, setVisible] = useState(false);
  const [email, setEmail] = useState("");
  const [showLiveWebinar, setShowLiveWebinar] = useState(false);
  const [contestData, setContestData] = useState([]);
  const [open, setOpen] = useState(false);

  const fetchContestData = async () => {
    try {
      const data = await getDataBannerContest();
      setContestData(data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const onCloseModalContest = () => {
    setOpen(false);
    localStorage.setItem("contestPopupLastShow", new Date().toISOString());
  };

  useEffect(() => {
    fetchContestData();
    const initializeContest = async () => {
      try {
        const shouldShow = checkShowPopup(contestData);
        setOpen(shouldShow);
      } catch (error) {
        console.error("Error fetching contest data:", error);
      }
    };
    initializeContest();
  }, []);

  useEffect(() => {
    if (contestData?.data) {
      if (
        contestData.data.status === "end" ||
        contestData.data.is_joined === true
      ) {
        setOpen(false);
        return;
      }
      const lastShow = localStorage.getItem("contestPopupLastShow");
      if (lastShow) {
        const now = Date.now();
        const lastShowTime = new Date(lastShow).getTime();
        if (lastShowTime > now) {
          localStorage.removeItem("contestPopupLastShow");
          setOpen(true);
          return;
        }
        const timeSinceLastShow = now - lastShowTime;
        const oneHourInMs = 60 * 60 * 1000;
        setOpen(timeSinceLastShow >= oneHourInMs);
      } else {
        setOpen(true);
      }
    } else {
      setOpen(false);
    }
  }, [contestData]);

  let isPath = pathname.split("/", 4)[3];
  const onCloseVerify = () => {
    setIsOpenVerify(false);
  };
  const onCloseModalOpenAccount = () => {
    dispatch(updateModalOpenAccount("", false));
  };
  const onCloseCampaignClose = () => {
    dispatch(getBonusCampaign());
    dispatch(updateModalCampaign(false));
    const url = new URL(window.location.href);
    url.searchParams.delete("coupon");
    window.history.pushState({}, "", url.toString());
    window.location.reload();
    // history.push(`/${localStorage.getItem("locale")}/wallet/`);
  };
  useEffect(() => {
    requestPermission();
    // createWithToken();
    // initSocket();
    const newSocket = io(process.env.REACT_APP_SOCKET_URL, {
      transports: ["websocket"],
    });

    const initSocket = async () => {
      // const socket = io.connect(process.env.REACT_APP_SOCKET_URL);

      newSocket.emit("join", {
        ch: "user",
        token: await getuser(),
      });
      newSocket.on("withdrawal", (newMessage) => {
        if (newMessage.value === "rejected") {
          message.error("Withdrawal" + newMessage.value);
        } else {
          message.success("Withdrawal" + newMessage.value);
        }
      });
      newSocket.on("deposit", (newMessage) => {
        if (newMessage.value === "rejected") {
          message.error("Deposit" + newMessage.value);
        } else {
          message.success("Deposit" + newMessage.value);
        }
      });
      newSocket.on("verify", (newMessage) => {
        dispatch(getUserVerifyv2());
        if (newMessage.value === "rejected") {
          message.error("Verify " + newMessage?.value);
          // dispatch(getUserVerifyv2());
        } else if (newMessage.value === "processed") {
          // dispatch(getUserVerifyv2());
          if (
            props.location.pathname.includes("/wallet/fund") ||
            props.location.pathname.includes("/wallet/account")
          ) {
            setIsOpenVerify(false);
          } else {
            setIsOpenVerify(true);
          }
          // setIsOpenVerify(true);
        } else {
          // dispatch(getUserVerifyv2());
          // if (
          //   props.location.pathname.includes("dashboard") !== "/wallet/fund" &&
          //   props.location.pathname.includes("dashboard") !== "/wallet/account"
          // ) {
          //   dispatch(getUserVerifyv2());
          // }
          // dispatch(getUserVerifyv2());
          message.success("Verify " + newMessage?.value);
        }
      });
      newSocket.on("verify-bank", (newMessage) => {
        dispatch(getUserBookbankv2());

        if (newMessage.value === "rejected") {
          message.error("Verify bank" + newMessage?.value);
        } else {
          message.success("Verify bank" + newMessage?.value);
        }
      });
    };
    initSocket();
    return () => {
      newSocket.disconnect();
    };
  }, []);

  const fetchPartnerList = async () => {
    try {
      const { data } = await partnerlist();
      setPartner(data.data);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchHoliday = async () => {
    try {
      const { data } = await getHolidayNearby();
      setHoliday(data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchLiveWebinar = async () => {
    try {
      const { data } = await getLiveWebinar();
      if (data?.data?.is_streaming) {
        setShowLiveWebinar(true);
      } else {
        setShowLiveWebinar(false);
      }
    } catch (error) {
      console.log(error);
    }
  };
  // useEffect(() => {
  //   const intervalCall = setInterval(() => {
  //     fetchLiveWebinar();
  //   }, 60000);
  //   return () => {
  //     // clean up
  //     clearInterval(intervalCall);
  //   };
  // }, []);

  const [location, setLocation] = useState(null);

  const getCountry = async () => {
    try {
      const response = await fetch("https://portal.iux.com/api/country");
      if (!response.ok) {
        throw new Error("Failed to fetch country");
      }
      const data = await response.json();
      setLocation(data?.country);
    } catch (err) {
      console.error("Error:", err);
    } finally {
      console.log("");
    }
  };

  useEffect(() => {
    getCountry();
    // fetchStream();
    fetchLiveWebinar();
    props.getArchive();
    fetchPartnerList();
    fetchHoliday();
  }, []);
  useEffect(() => {}, [props?.user]);
  useEffect(() => {
    var locs = props?.user?.profile?.country_id === 8 ? "lo" : "en";
    localStorage.setItem("setLocale", locs);
    if (props?.user?.accounts !== props?.user?.accounts) {
      setEmail(props?.user?.profile?.email || "");
    }
    let loc = localStorage.getItem("locale");
    if (props?.user?.profile?.country_id !== 8 || loc !== "lo") {
      setModalLang(localStorage.getItem("locale" || "lo"));
    }
    setPathname(props.location.pathname);
    if (props?.user?.server_status === 1) {
      setMt(true);
    }
  }, [props.user, props.location]);
  const renderNavList = () => {
    let isPath = pathname.split("/", 4)[3];
    return navigationList.map((item, index) => {
      if (item.divider) {
        return "";
      } else {
        return (
          <div
            id={item.title}
            className="mb-2"
            key={item.path}
            onClick={() => {
              onClose();
              navigate(item.path);
              setPathname(item.path);
            }}
          >
            <BoxMenuItem Background={isPath === item.name ? "#fff" : ""}>
              <div>
                <img
                  src={isPath === item.name ? item.icon_ac : item.icon}
                  alt={"menu"}
                  className="m-auto"
                />
              </div>
              <div>
                <span
                  className="nav-text text-capitalize"
                  style={{
                    fontSize: 10,
                    color: isPath === item.name ? "#1CB894" : "",
                  }}
                >
                  {locale.t(item.title)}
                  {/* {item.name === "webinar" && (
                    <Countdown
                      title={locale.t("countdown")}
                      value={moment().add(5, "s").toDate()}
                      onFinish={() => setShowLiveWebinar(true)}
                      style={{
                        display: "none",
                      }}
                    />
                  )} */}
                </span>
                {item.name === "webinar" && showLiveWebinar && (
                  <div className="d-flex justify-content-center">
                    <div
                      className="fs-8"
                      style={{
                        color: "#FFF",
                        background: "#EF4533",
                        width: 32,
                        borderRadius: 10,
                      }}
                    >
                      Live
                    </div>
                  </div>
                )}
              </div>
            </BoxMenuItem>
          </div>
        );
      }
    });
  };
  const renderNavListMobile = () => {
    return navigationList.map((item, i) => {
      if (item.divider) {
        return (
          <Menu.Divider
            key={i}
            className="mx-4"
            style={{ backgroundColor: "#d9d9d9", margin: "24px 0" }}
          />
        );
      } else {
        return (
          <Menu.Item
            style={{ display: "flex", alignItems: "center" }}
            className={`${
              isPath === item.name ? "menu-active" : "menu-inactive"
            } text-main-black `}
            key={item.path}
            onClick={() => {
              onClose();
              navigate(item.path);
              setPathname(item.path);
            }}
          >
            <img
              src={isPath === item.name ? item.icon_ac : item.icon}
              alt={"menu"}
              width={20}
              className="d-inline"
            />
            <span className="nav-text ml-2">{locale.t(item.title)} </span>
            {item.name === "webinar" && showLiveWebinar && (
              <span
                className="fs-8 my-auto"
                style={{
                  color: "#FFF",
                  background: "#EF4533",
                  width: 32,
                  borderRadius: 10,
                  padding: "1px 8px",
                }}
              >
                Live
              </span>
            )}
          </Menu.Item>
        );
      }
    });
  };
  const renderNavListMobileBottom = () => {
    let isPath = pathname.split("/", 4)[3];
    return otherMenu.map((item, i) => {
      if (item.divider) {
        return <Menu.Divider key={i} />;
      } else {
        return (
          <Menu.Item
            style={{ display: "flex", alignItems: "center" }}
            className={`${
              isPath === item.name ? "menu-active" : "menu-inactive"
            } text-main-black `}
            key={item.path}
            onClick={() => {
              if (item.name === "partner") {
                window.location.replace(item.path);
              } else {
                onClose();
                navigate(item.path);
                setPathname(item.path);
              }
            }}
          >
            <img
              src={isPath === item.name ? item.icon_ac : item.icon}
              alt={"menu"}
              width={20}
              className="d-inline"
            />
            <span className="nav-text ml-2">{locale.t(item.title)}</span>
          </Menu.Item>
        );
      }
    });
  };
  const onLogout = () => {
    // onDeleteToken();
    // props.LogoutAuth();
    // history.push(`/${localStorage.getItem("locale")}/login`);
    try {
      onDeleteToken();
      props.LogoutAuth();
      history.push(`/${localStorage.getItem("locale")}/login`);
    } catch (error) {
      console.log(error);
    }
  };
  const onDeleteToken = () => {
    try {
      deleteTokenFCM();
    } catch (error) {
      console.log(error);
    }
  };
  const navigate = (path) => {
    if (props?.user?.server_status === 1) {
      history.push({ pathname: path });
    } else {
      props.LogoutAuth();
    }
  };

  const showLang = () => {
    setVisibleLang(true);
  };

  const cancelLang = () => {
    setVisibleLang(false);
  };
  const showDrawer = () => {
    setVisible(true);
  };
  const onClose = () => {
    setVisible(false);
  };
  const showChildrenDrawer = () => {
    setDrawerLangMobile(true);
  };

  const onChildrenDrawerClose = () => {
    setDrawerLangMobile(false);
  };

  const closeModalLang = () => {
    setModalLang(false);
  };

  const handleChangLanguage = async (newLang) => {
    const oldLang = localStorage.getItem("locale");
    localStorage.setItem("locale", newLang);
    const newPath = history.location.pathname.replace(oldLang, newLang);
    history.push(newPath);

    closeModalLang();
    const payload = {
      device: "web",
      lang_iso: CheckLanguageISO(newLang),
    };
    try {
      const { data } = await patchTokenFCM(payload);
    } catch (error) {
      console.log(error);
    }

    window.location.reload();
  };
  const onChangeIsCreate = () => {
    dispatch(setModalBonus(false));
  };
  const onClickBonus = () => {
    if (
      props?.user?.bonus_config?.bonus_countries?.find(
        (e) => e === props?.user?.profile?.country_id
      )
    ) {
      if (
        props.user.bookBankVerify.status === "accepted" &&
        props.user.userVerify.status === "accepted"
      ) {
        dispatch(setModalBonus(true));
      } else {
        if (props.user.userVerify.status !== "accepted") {
          message.error(locale.t("open_account.error_er"));
          history.push(
            `/${localStorage.getItem("locale")}/wallet/account/Standard`
          );
        } else {
          message.error(locale.t("open_account.error_bank"));
          history.push(
            `/${localStorage.getItem("locale")}/wallet/fund/withdraw`
          );
        }
      }
    } else {
      history.push(`/${localStorage.getItem("locale")}/wallet/receivebonus`);
    }
  };

  const renderMaintenance = () => {
    let a = props?.user?.accounts.filter((account) => account.type === "real");

    var sumUsingReduce = 0;
    var total = a.reduce(function (sum, value) {
      if (value.account_type === "Cent") {
        return (sumUsingReduce += Number(value.current_balance / 100));
      } else {
        return (sumUsingReduce += Number(value.current_balance));
      }
    }, 0);

    if (props?.user?.server_status === 1) {
      return (
        <Layout style={{ minHeight: "100vh" }}>
          {/* <SocialButtonDashboard /> */}
          <Layout style={{ height: "100%" }}>
            {/* <DownloadApp /> */}
            <Header
              style={{
                display: "flex",
                background: "#FFF",
                padding: 0,
                alignItems: "center",
              }}
            >
              <div className="container d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <div className="hamburger">
                    <button
                      className="d-flex btn-transparent fs-20"
                      onClick={showDrawer}
                    >
                      <MenuOutlined />
                    </button>
                  </div>

                  <div className="col-md logo-autoNav pl-0 pr-0 d-flex">
                    <div className="logo-w m-auto">
                      <Link
                        to={`/${localStorage.getItem("locale")}/wallet`}
                        style={{ padding: 0 }}
                      >
                        <Logo
                          variant="withoutBgV2"
                          size="md"
                          className="logo-dashboard m-auto"
                        />
                      </Link>
                    </div>
                  </div>
                </div>

                <div
                  className="col-md text-main-black hide-navWallet"
                  style={{ textAlign: "right" }}
                >
                  <div className="d-flex user" style={{ float: "right" }}>
                    <div onClick={showLang}>
                      <div
                        className="text-main-black"
                        style={{ cursor: "pointer" }}
                      >
                        <div className="d-flex ml-2">
                          <div className="col-md">
                            <div
                              style={{ textTransform: "uppercase" }}
                              className="d-flex align-items-center text-main-black"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <g clip-path="url(#clip0_6194_14137)">
                                  <path
                                    d="M14.5976 12.5196C15.4817 11.2329 16 9.67625 16 8.00056C16 3.589 12.4116 0 8.00056 0C6.38888 0 4.88728 0.479469 3.63006 1.30259C3.60075 1.31813 3.57356 1.33613 3.54856 1.35628C1.40997 2.79391 0 5.23559 0 8.00056C0 12.4116 3.589 16 8.00056 16C10.6963 16 13.0847 14.6596 14.5346 12.6104C14.5588 12.5828 14.5797 12.5522 14.5976 12.5196ZM8.00056 14.9761C4.15366 14.9761 1.02394 11.8469 1.02394 8.00056C1.02394 5.76391 2.08216 3.76994 3.72397 2.49231C3.97134 2.79825 4.27216 2.99019 4.59297 3.03737C4.64953 3.04569 4.70669 3.04959 4.76438 3.04959C5.15734 3.04959 5.56975 2.86794 6.00378 2.67684C6.17156 2.60278 6.34684 2.52541 6.52712 2.45662C6.79116 2.35569 6.92372 2.05975 6.82275 1.79575C6.72209 1.53144 6.42616 1.39944 6.16187 1.50013C5.96525 1.57528 5.77387 1.65903 5.59084 1.73975C5.28022 1.87647 4.89253 2.04481 4.74219 2.02428C4.70056 2.01809 4.64437 1.98225 4.58319 1.92019C5.54903 1.37519 6.65675 1.05344 7.83609 1.026C7.73697 1.40488 7.61044 1.85944 7.48612 1.99125C7.32722 2.15931 7.02547 2.30684 6.7595 2.43722C6.32103 2.65159 5.86788 2.87347 5.76303 3.32747C5.72253 3.50275 5.72366 3.77566 5.96022 4.07903C6.37538 4.61178 7.12169 4.6265 7.84359 4.64091C8.24297 4.64866 8.69528 4.65753 8.90522 4.77209C8.97484 4.81009 9.03891 4.903 9.06525 5.00313C9.08687 5.0855 9.07275 5.13263 9.06997 5.13819C9.06969 5.13847 9.05444 5.15041 9.02919 5.15678C8.98897 5.15234 8.88109 5.09966 8.80981 5.06472C8.66866 4.99594 8.50834 4.91747 8.32197 4.8875C8.07153 4.847 7.84913 4.88 7.67022 4.90637C7.57009 4.92106 7.49022 4.93272 7.40425 4.93384C7.26475 4.93356 7.1075 4.90584 6.94109 4.87644C6.57003 4.81072 6.10853 4.72919 5.63541 4.93994C5.18612 5.13991 4.80175 5.567 4.49306 5.91034C4.42013 5.99159 4.3505 6.06897 4.28478 6.13803L4.22431 6.20125C3.52959 6.92759 3.02763 7.45231 3.63303 8.78406C3.98025 9.54756 4.33663 10.1316 5.47981 10.1316C5.48369 10.1316 5.48731 10.1316 5.49091 10.1316C5.79903 10.1305 6.08219 10.0492 6.33206 9.97772C6.41775 9.95303 6.53341 9.91975 6.61881 9.90284C6.62519 9.94584 6.63047 10.0068 6.63128 10.0909C6.63572 10.5288 6.90472 10.7751 7.06559 10.9221C7.10581 10.9592 7.16681 11.015 7.17597 11.028C7.17597 11.028 7.17791 11.0452 7.16794 11.0865C7.13244 11.2327 7.08556 11.3042 7.0265 11.3947C6.8615 11.6476 6.72919 11.918 6.91306 12.4397L6.9125 12.4402L6.92637 12.4771C6.92803 12.4815 6.92969 12.486 6.93138 12.4907C6.9325 12.4932 6.93331 12.496 6.93444 12.4984C6.97381 12.6072 7.01181 12.768 7.05231 12.9383C7.19431 13.5365 7.47609 14.7257 8.50722 14.7254C8.60428 14.7254 8.70828 14.7152 8.82006 14.6933C9.71169 14.5119 10.1244 13.4999 10.3973 12.8307C10.4183 12.7788 10.443 12.7189 10.4663 12.6632C10.8094 12.616 11.0612 12.4904 11.2323 12.2835C11.5385 11.9119 11.4523 11.446 11.3893 11.1054C11.3699 11.0008 11.3388 10.835 11.3436 10.7543C11.8752 10.5327 12.9635 10.074 12.7987 9.10916C12.7261 8.68094 12.3498 8.301 11.8736 7.82009C11.5036 7.44625 10.8152 6.75069 10.9528 6.49444C11.0868 6.24541 10.9933 5.93506 10.7443 5.80109C10.4958 5.66741 10.1849 5.76059 10.0509 6.00966C9.55475 6.93291 10.437 7.82397 11.1458 8.54034C11.3857 8.78247 11.7485 9.14853 11.7892 9.28081C11.7959 9.31991 11.7543 9.47356 10.9397 9.81275C10.1679 10.1347 10.3124 10.916 10.382 11.2915C10.4003 11.3908 10.4292 11.5464 10.4275 11.6279C10.3867 11.6409 10.3013 11.6593 10.1438 11.6606C10.0046 11.662 9.872 11.7194 9.77603 11.8207C9.64791 11.9557 9.56859 12.1498 9.44878 12.4441C9.28128 12.854 8.97009 13.6172 8.61537 13.6896C8.39184 13.7365 8.26372 13.6081 8.04906 12.7026C8.00469 12.5145 7.96225 12.3359 7.90734 12.1776L7.90791 12.1773L7.89459 12.1421C7.89294 12.1376 7.89153 12.134 7.88987 12.1298C7.88959 12.1287 7.88903 12.1273 7.88875 12.1263C7.86519 12.0638 7.85519 12.0256 7.85103 12.0048C7.86075 11.9884 7.87209 11.9729 7.88375 11.9554C7.96419 11.8317 8.08622 11.6456 8.16303 11.3281C8.31972 10.6816 7.9395 10.3338 7.75675 10.1666C7.71847 10.1314 7.65663 10.0803 7.65525 10.0803C7.65191 9.75919 7.60672 9.30188 7.25228 9.03756C6.87566 8.75634 6.4175 8.88753 6.04975 8.99319C5.85506 9.04894 5.65344 9.10662 5.48759 9.10719C4.94153 9.10247 4.85472 8.99597 4.56547 8.35978C4.24653 7.65897 4.30091 7.60209 4.96428 6.90878L5.02528 6.845C5.09766 6.76928 5.17422 6.68416 5.25437 6.59513C5.49816 6.32416 5.80128 5.98666 6.05144 5.87544C6.22975 5.79613 6.43775 5.82719 6.76281 5.88459C6.95584 5.91844 7.17409 5.95725 7.40234 5.95753C7.55181 5.95753 7.69631 5.93728 7.81919 5.91925C7.95091 5.89956 8.06462 5.88238 8.15866 5.89819C8.19525 5.904 8.29428 5.95253 8.35972 5.98472C8.56522 6.08512 8.84562 6.22184 9.17341 6.16859C9.664 6.08788 10.0043 5.75925 10.0839 5.28972C10.176 4.74616 9.88006 4.13713 9.39528 3.87309C8.96569 3.63931 8.40575 3.62822 7.86412 3.61741C7.57597 3.61159 7.135 3.603 6.89622 3.517C6.99469 3.46209 7.11559 3.403 7.20959 3.35697C7.55403 3.18834 7.94453 2.99728 8.23047 2.69412C8.54941 2.35687 8.69944 1.77669 8.85863 1.16241C8.86584 1.13472 8.87306 1.10703 8.88025 1.07931C11.877 1.45812 14.2868 3.74603 14.8506 6.68237C14.8073 6.66194 14.7552 6.6355 14.6918 6.60178C14.4342 6.4645 14.0817 6.27703 13.6754 6.41209C13.286 6.54187 13.1396 6.89994 13.0525 7.11431C12.8356 6.96234 12.4054 6.53578 12.0901 6.18331C11.9015 5.97253 11.5779 5.95422 11.3674 6.14281C11.1569 6.33113 11.1383 6.65478 11.3269 6.86556C11.4689 7.02447 12.1994 7.82847 12.6384 8.06003C12.8245 8.15822 13.0009 8.20728 13.1664 8.20728C13.2591 8.20728 13.3484 8.19175 13.4338 8.16097C13.7835 8.03366 13.9136 7.71362 14.0004 7.50175C14.0103 7.47678 14.0231 7.446 14.0356 7.41716C14.0902 7.44184 14.1585 7.47791 14.21 7.50562C14.3905 7.60197 14.6593 7.745 14.9716 7.76369C14.9742 7.84241 14.976 7.92134 14.976 8.00069C14.976 9.12797 14.7069 10.1934 14.2301 11.1368C14.0404 10.9852 13.7494 10.846 13.3101 10.8231C12.8552 10.7965 12.0254 10.9928 11.5756 12.5667C11.498 12.8382 11.6555 13.1219 11.9273 13.1996C11.9742 13.2132 12.0218 13.2196 12.0684 13.2196C12.2909 13.2196 12.4958 13.0728 12.5602 12.8482C12.741 12.217 13.0017 11.8288 13.2563 11.8457C13.5114 11.8593 13.5916 11.9328 13.6102 11.9549C13.6365 11.9866 13.6457 12.0387 13.6474 12.0909C12.3785 13.8378 10.3201 14.9761 8.00056 14.9761Z"
                                    fill="#1E1E1E"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_6194_14137">
                                    <rect width="16" height="16" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                              <p className="ml-2" style={{ fontSize: "12px" }}>
                                {localStorage.getItem("locale")}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <Drawer
                      placement="right"
                      closable={false}
                      onClose={cancelLang}
                      visible={visibleLang}
                    >
                      <div className="bg-white h-100">
                        <div style={{ padding: "12px" }} className="row">
                          {languageSupport.map((i, index) => (
                            <div key={index} className="col-md-12 pl_pr_8">
                              <Link
                                className="text-white"
                                to="#"
                                onClick={() => handleChangLanguage(i.lang)}
                              >
                                <div
                                  className="justify-content-between onHoverLang"
                                  style={{ padding: "8px" }}
                                >
                                  <div className="d-flex align-items-center">
                                    {/* <img
                                      className="mr-2"
                                      style={flagStyle}
                                      src={process.env.PUBLIC_URL + i.img}
                                      alt="language"
                                    /> */}
                                    <span className={`fi fi-${i?.img}`} />{" "}
                                    &nbsp;
                                    <p style={{ color: "black" }}>{i.name}</p>
                                  </div>
                                </div>
                              </Link>
                            </div>
                          ))}
                        </div>
                      </div>
                    </Drawer>{" "}
                    <Dropdown
                      placement="bottomRight"
                      overlay={
                        <div className="row dashboard-container ">
                          <div
                            className="col-6 d-flex pt-3 justify-content-center flex-column align-items-center cursor-pointer header-menu-icons-dropdown"
                            onClick={() => {
                              navigate(
                                `/${localStorage.getItem(
                                  "locale"
                                )}/wallet/tradingprogram`
                              );
                            }}
                          >
                            <div className="ml-2 ">
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M4.75 11.25L7.25 6.75L9.75 9.25L13.25 3.25M1.75 1.75V14.25H14.25"
                                  stroke="#1E1E1E"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  className="fill-primary"
                                />
                              </svg>
                            </div>
                            <div className="ml-2 mt-2 fs-12 text-center">
                              {locale.t("program")}
                              {/* {locale.t("dashboardProgram.title")} */}
                            </div>
                          </div>
                          <div
                            className="col-6 d-flex pt-3 justify-content-center flex-column align-items-center cursor-pointer header-menu-icons-dropdown"
                            onClick={() => {
                              navigate(
                                `/${localStorage.getItem(
                                  "locale"
                                )}/wallet/tradingsoftware`
                              );
                            }}
                          >
                            <div className="ml-2 ">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="12"
                                viewBox="0 0 16 12"
                                fill="none"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M1.99935 0H13.9993C14.7357 0 15.3327 0.596954 15.3327 1.33333V10.6667C15.3327 11.403 14.7357 12 13.9993 12H1.99935C1.26297 12 0.666016 11.403 0.666016 10.6667V1.33333C0.666016 0.596954 1.26297 0 1.99935 0ZM1.99935 1.33333V10.6667H13.9993V1.33333H1.99935ZM4.66602 9.33333H5.99935V5.33333H4.66602V9.33333ZM8.66602 9.33333H7.33268V2.66667H8.66602V9.33333ZM9.99935 9.33333H11.3327V4.66667H9.99935V9.33333Z"
                                  fill="#1E1E1E"
                                  className="fill-primary"
                                />
                              </svg>
                            </div>
                            <div className="ml-2 mt-2 fs-12 text-center">
                              {/* {locale.t("program")} */}
                              {locale.t("dashboardProgram.title")}
                            </div>
                          </div>
                          <div
                            className="col-6 d-flex py-3 justify-content-center flex-column align-items-center cursor-pointer header-menu-icons-dropdown"
                            onClick={() => {
                              window.open("https://partner.iuxmarkets.com");
                            }}
                          >
                            <div className="ml-2">
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5 11.25C6.24264 11.25 7.25 10.2426 7.25 9C7.25 7.75736 6.24264 6.75 5 6.75C3.75736 6.75 2.75 7.75736 2.75 9C2.75 10.2426 3.75736 11.25 5 11.25Z"
                                  stroke="#1E1E1E"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  className="fill-primary"
                                />
                                <path
                                  d="M11 6.25C12.2426 6.25 13.25 5.24264 13.25 4C13.25 2.75736 12.2426 1.75 11 1.75C9.75736 1.75 8.75 2.75736 8.75 4C8.75 5.24264 9.75736 6.25 11 6.25Z"
                                  stroke="#1E1E1E"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  className="fill-primary"
                                />
                                <path
                                  d="M7.75 9.25C7.75 8.25 8.5 6.25 11 6.25C13.5 6.25 14.25 8.25 14.25 9.25M1.75 14.25C1.75 13.25 2.5 11.25 5 11.25C7.5 11.25 8.25 13.25 8.25 14.25"
                                  stroke="#1E1E1E"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  className="fill-primary"
                                />
                              </svg>
                            </div>
                            <div className="ml-2 mt-2 fs-12">
                              {" "}
                              {locale.t("partner")}
                            </div>
                          </div>
                          <div
                            className="col-6 d-flex py-3 justify-content-center flex-column align-items-center cursor-pointer header-menu-icons-dropdown"
                            onClick={() => {
                              navigate(
                                `/${localStorage.getItem(
                                  "locale"
                                )}/wallet/typeaccount`
                              );
                            }}
                          >
                            <div className="ml-2 ">
                              <svg
                                width="16"
                                height="17"
                                viewBox="0 0 16 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M4 7.5H9.5V8.5H4V7.5ZM4 10H10.5V11H4V10Z"
                                  fill="#1E1E1E"
                                  className="fill-primary"
                                />
                                <path
                                  d="M14 2.5H2C1.73478 2.5 1.48043 2.60536 1.29289 2.79289C1.10536 2.98043 1 3.23478 1 3.5V13.5C1 13.7652 1.10536 14.0196 1.29289 14.2071C1.48043 14.3946 1.73478 14.5 2 14.5H14C14.2652 14.5 14.5196 14.3946 14.7071 14.2071C14.8946 14.0196 15 13.7652 15 13.5V3.5C15 3.23478 14.8946 2.98043 14.7071 2.79289C14.5196 2.60536 14.2652 2.5 14 2.5ZM14 3.5V4.5H2V3.5H14ZM2 13.5V5.5H14V13.5H2Z"
                                  fill="#1E1E1E"
                                  className="fill-primary"
                                />
                              </svg>
                            </div>
                            <div className="ml-2 mt-2 fs-12">
                              {locale.t("accounttype")}
                            </div>
                          </div>
                          {/* <div
                            className="col-6 d-flex py-3 justify-content-center flex-column align-items-center cursor-pointer header-menu-icons-dropdown"
                            onClick={() => {
                              navigate(
                                `/${localStorage.getItem(
                                  "locale"
                                )}/wallet/contact`
                              );
                            }}
                          >
                            <div className="ml-2 ">
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M1.75 11.75C1.75 9.25 5.25 9.75 5.25 9.75V14.25C5.25 14.25 1.75 14.75 1.75 11.75ZM1.75 11.75V8.25C1.75 5.25 2.25 1.75 8 1.75C13.75 1.75 14.25 5.25 14.25 8.25V11.75M14.25 11.75C14.25 14.75 10.75 14.25 10.75 14.25V9.75C10.75 9.75 14.25 9.25 14.25 11.75Z"
                                  stroke="#1E1E1E"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  className="fill-primary"
                                />
                              </svg>
                            </div>
                            <div className="ml-2 mt-2 fs-12">
                              {locale.t("contact")}
                            </div>
                          </div> */}
                        </div>
                      }
                      trigger={["click"]}
                    >
                      <div
                        onClick={(e) => e.preventDefault()}
                        className="cursor-pointer mx-3 d-flex"
                      >
                        <Space>
                          <div className="header-menu-icons cursor-pointer">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M7 10.75H5C2.58 10.75 1.25 9.42 1.25 7V5C1.25 2.58 2.58 1.25 5 1.25H7C9.42 1.25 10.75 2.58 10.75 5V7C10.75 9.42 9.42 10.75 7 10.75ZM5 2.75C3.42 2.75 2.75 3.42 2.75 5V7C2.75 8.58 3.42 9.25 5 9.25H7C8.58 9.25 9.25 8.58 9.25 7V5C9.25 3.42 8.58 2.75 7 2.75H5Z"
                                fill="#1E1E1E"
                                className="fill-primary"
                              />
                              <path
                                d="M19 10.75H17C14.58 10.75 13.25 9.42 13.25 7V5C13.25 2.58 14.58 1.25 17 1.25H19C21.42 1.25 22.75 2.58 22.75 5V7C22.75 9.42 21.42 10.75 19 10.75ZM17 2.75C15.42 2.75 14.75 3.42 14.75 5V7C14.75 8.58 15.42 9.25 17 9.25H19C20.58 9.25 21.25 8.58 21.25 7V5C21.25 3.42 20.58 2.75 19 2.75H17Z"
                                fill="#1E1E1E"
                                className="fill-primary"
                              />
                              <path
                                d="M19 22.75H17C14.58 22.75 13.25 21.42 13.25 19V17C13.25 14.58 14.58 13.25 17 13.25H19C21.42 13.25 22.75 14.58 22.75 17V19C22.75 21.42 21.42 22.75 19 22.75ZM17 14.75C15.42 14.75 14.75 15.42 14.75 17V19C14.75 20.58 15.42 21.25 17 21.25H19C20.58 21.25 21.25 20.58 21.25 19V17C21.25 15.42 20.58 14.75 19 14.75H17Z"
                                fill="#1E1E1E"
                                className="fill-primary"
                              />
                              <path
                                d="M7 22.75H5C2.58 22.75 1.25 21.42 1.25 19V17C1.25 14.58 2.58 13.25 5 13.25H7C9.42 13.25 10.75 14.58 10.75 17V19C10.75 21.42 9.42 22.75 7 22.75ZM5 14.75C3.42 14.75 2.75 15.42 2.75 17V19C2.75 20.58 3.42 21.25 5 21.25H7C8.58 21.25 9.25 20.58 9.25 19V17C9.25 15.42 8.58 14.75 7 14.75H5Z"
                                fill="#1E1E1E"
                                className="fill-primary"
                              />
                            </svg>
                          </div>
                        </Space>{" "}
                      </div>
                    </Dropdown>
                    <div className="mx-3 d-flex">
                      {windowWidthRespone > 768 && <Notification />}
                    </div>
                    <div className="ml-3" />{" "}
                    <Dropdown
                      overlay={
                        <Menu
                          theme="dark"
                          className=" text-white border-12"
                          style={{
                            width: 220,
                            borderRadius: 12 + "!important",
                            background: "#fff",
                          }}
                        >
                          <Menu.Item
                            style={{
                              "&:hover": {
                                background: "#1CB894",
                              },
                              padding: 12,
                            }}
                            onClick={() => {
                              navigate(
                                `/${localStorage.getItem(
                                  "locale"
                                )}/wallet/setting`
                              );
                            }}
                          >
                            <span className="ml-2 text-main-black">
                              <img
                                src="/assets/images/icons/menu/setting.svg"
                                alt="setting"
                                className="d-inline"
                              />
                            </span>
                            <span className="ml-2 text-main-black">
                              {locale.t("setting_pages")}
                            </span>
                          </Menu.Item>
                          <Menu.Item
                            className="text-main-black"
                            style={{
                              "&:hover": {
                                background: "#000",
                              },
                              padding: 12,
                            }}
                            onClick={() => {
                              localStorage.removeItem("showbonus30");
                              localStorage.removeItem("tutorialHide");
                              onLogout();
                            }}
                          >
                            <span className="ml-2 text-main-black">
                              <img
                                src="/assets/images/icons/menu/logout-m.svg"
                                alt="signout"
                                className="d-inline"
                              />
                            </span>
                            <span className="ml-2 text-main-black">
                              {locale.t("menuWallet.signOut")}
                            </span>
                          </Menu.Item>
                        </Menu>
                      }
                      trigger={["click"]}
                      placement="bottomRight"
                    >
                      <div
                        onClick={(e) => e.preventDefault()}
                        className="cursor-pointer d-flex"
                      >
                        <Space>
                          <img
                            src="/assets/images/icons/user-nav.svg"
                            alt="user-icons"
                            className="d-inline"
                          />
                        </Space>{" "}
                      </div>
                    </Dropdown>
                  </div>
                </div>
                <div className="hamburger">
                  <div className="d-flex align-items-center">
                    <div>
                      <div className="d-flex">
                        <div
                          className="col-md btn  d-block"
                          onClick={() => showChildrenDrawer()}
                        >
                          <div
                            style={{ textTransform: "uppercase" }}
                            className=" d-flex justify-content-between"
                          >
                            <div className="d-flex">
                              <span
                                className={`fi fi-${CheckLanguageImg(
                                  localStorage.getItem("locale")
                                )}`}
                              />
                              <div className="" style={{ fontSize: "12px" }}>
                                {localStorage.getItem("locale").toUpperCase()}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <Drawer
                        className=""
                        width="100%"
                        height="100%"
                        closable={false}
                        placement="left"
                        onClose={onChildrenDrawerClose}
                        visible={drawerLangMobile}
                        // visible
                      >
                        <>
                          <div
                            className="d-flex justify-content-end"
                            style={{
                              borderBottom: "1px solid #ffffff1a",
                              padding: "12px",
                            }}
                          >
                            <div
                              className="d-flex justify-content-end"
                              style={{ order: "2" }}
                            >
                              <button
                                className="d-flex btn-transparent mr-2"
                                onClick={onChildrenDrawerClose}
                              >
                                <span>
                                  <CloseOutlined />
                                </span>
                              </button>
                            </div>
                          </div>
                          <Menu>
                            {languageSupport.map((i, index) => (
                              <Menu.Item key={index}>
                                <Link
                                  className="text-black"
                                  to="#"
                                  onClick={() => handleChangLanguage(i.lang)}
                                >
                                  <div className="d-flex justify-content-between text-main-black">
                                    <div>
                                      <span className={`fi fi-${i?.img}`} />
                                      {/* <img
                                            className="mr-2 mb-1 rounded shadow"
                                            style={flagStyle}
                                            src={process.env.PUBLIC_URL + i.img}
                                            alt=""
                                          /> */}
                                      &nbsp;
                                    </div>
                                    <p className="text-left">{i.name}</p>
                                  </div>
                                </Link>
                              </Menu.Item>
                            ))}
                          </Menu>
                        </>
                      </Drawer>
                    </div>
                    <div className="mx-3">
                      {windowWidthRespone < 768 && <Notification />}
                    </div>
                  </div>
                </div>
              </div>
            </Header>

            <div>
              {partner.length > 1 && <PartnerNoti data={partner} />}

              {/* {holiday && <HolidayNoti dataholiday={holiday} />} */}
            </div>
            <Layout>
              <Layout className="container">
                <Sider
                  theme="light"
                  style={{ background: "transparent" }}
                  breakpoint="sm"
                  collapsedWidth="0"
                  onBreakpoint={(broken) => {
                    setBroken(broken);
                  }}
                  className={`${isPath === "webinar" && "d-none"}`}
                >
                  <div activekey={pathname} selectedkeys={[pathname]}>
                    {props?.user?.bonus_config?.bonus_countries?.find(
                      (e) => e === props?.user?.profile?.country_id
                    ) &&
                    props.user.accountTradeBonusId.isRecived === null &&
                    props?.user?.accounts?.filter((e) => e.type === "welcome")
                      .length === 0 ? (
                      <div className="mb-3">
                        <button
                          onClick={() => onClickBonus()}
                          className="w-100 btn-gradient-bonus fs-12 d-flex align-items-center px-3"
                          style={{ lineHeight: "120%", fontWeight: 300 }}
                        >
                          <div>
                            <GiftOutlined
                              width={16}
                              height={16}
                              className="fs-16"
                            />{" "}
                          </div>
                          <div
                            style={{
                              wordBreak: "break-all",
                              paddingRight: "1px",
                            }}
                          >
                            {locale.t("menuWallet.getBonus")}
                          </div>
                        </button>
                      </div>
                    ) : null}
                    {renderNavList()}
                  </div>
                </Sider>
                <Drawer
                  width="100%"
                  height="100%"
                  closable={false}
                  onClose={onClose}
                  visible={visible}
                  placement="left"
                >
                  <div className="pt-5 ">
                    <div className="d-flex justify-content-between align-items-center">
                      <div style={{ order: "2" }}>
                        <button
                          className="d-flex btn-transparent mr-2"
                          onClick={onClose}
                        >
                          <span>
                            <CloseOutlined className="fs-16" />
                          </span>
                        </button>
                      </div>
                      <div className="ml-3">
                        <Link
                          to={`/${localStorage.getItem("locale")}/wallet/`}
                          style={{ padding: 0 }}
                        >
                          <Logo
                            variant="withoutBgV2"
                            size="sm"
                            className="logo-dashboard"
                          />
                        </Link>
                      </div>
                    </div>
                    <div className="d-flex mt-4 border-tbWallet">
                      <div className="col-md">
                        <Link
                          to={`/${localStorage.getItem(
                            "locale"
                          )}/wallet/setting`}
                          onClick={onClose}
                          style={{ textTransform: "uppercase" }}
                        >
                          <div className="d-flex align-items-center text-primary-new-iux">
                            <div>
                              {props?.user?.profile?.first_name}{" "}
                              {props?.user?.profile?.last_name}
                            </div>
                            {/* <div className="ml-1">
                              <SettingOutlined />
                            </div> */}
                          </div>
                        </Link>
                        <div>{props?.user?.profile?.email}</div>
                      </div>
                    </div>
                  </div>
                  <Menu
                    theme="light"
                    mode="inline"
                    activekey={pathname}
                    selectedkeys={[pathname]}
                  >
                    {props?.user?.bonus_config?.bonus_countries?.find(
                      (e) => e === props?.user?.profile?.country_id
                    ) &&
                    props.user.accountTradeBonusId.isRecived === null &&
                    props?.user?.accounts?.filter((e) => e.type === "welcome")
                      .length === 0 ? (
                      <div className="d-flex">
                        <button
                          onClick={() => onClickBonus()}
                          className="w-100 m-3 mt-4 btn-gradient-bonus fs-12"
                        >
                          <GiftOutlined
                            width={16}
                            height={16}
                            className="fs-16"
                          />{" "}
                          &nbsp;
                          {locale.t("menuWallet.getBonus")}
                        </button>
                      </div>
                    ) : null}

                    {renderNavListMobile()}
                    {/* {otherMenu.map((item, i) => (
                      <Menu.Item
                        style={{ display: "flex", alignItems: "center" }}
                        key={item.nmae}
                        onClick={() => {
                          onClose();
                          navigate(item.path);
                          setPathname(item.path);
                        }}
                      >
                        <img
                          src={process.env.PUBLIC_URL + item.icon}
                          alt={"menu"}
                          width={20}
                        />
                        <span className="nav-text ml-2">
                          {locale.t(item?.name)}
                        </span>
                      </Menu.Item>
                    ))} */}
                    {renderNavListMobileBottom()}
                    <Menu.Item
                      style={{ display: "flex", alignItems: "center" }}
                      key="logout"
                      onClick={() => onLogout()}
                    >
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/icons/menu/logout-m.svg"
                        }
                        alt={"menu"}
                        className="d-inline"
                      />
                      <span className="nav-text ml-2">
                        {locale.t("menuWallet.signOut")}
                      </span>
                    </Menu.Item>
                  </Menu>
                </Drawer>

                <Content className="pt-3 ml-0 ml-md-3 d-flex flex-column">
                  <ModalContest
                    isOpen={open}
                    onClose={() => onCloseModalContest()}
                    contestData={contestData}
                  />
                  <div className="d-flex flex-column" style={{ flex: 1 }}>
                    <Switch>
                      <Route
                        path={"/:lang/wallet/swap"}
                        exact
                        component={Swap}
                      />
                      <Route
                        path={"/:lang/wallet/transfer"}
                        exact
                        component={Transfer}
                      />

                      <Route
                        path="/:lang/wallet/spread/symbol/analyze/:id"
                        render={() => (
                          <Analyzesymbol
                            current="analyze"
                            islayout="dashboard"
                          />
                        )}
                      />
                      {/* <Route
                      path="/:lang/wallet/spread/marketresearch"
                      render={() => (
                        <MarketResearch
                          current="research"
                          islayout="dashboard"
                        />
                      )}
                    /> */}
                      <Route
                        path="/:lang/wallet/spread"
                        render={() => (
                          <Symbol current="symbol" islayout="dashboard" />
                        )}
                      />
                      <Route
                        path={"/:lang/wallet"}
                        exact
                        render={(props) => {
                          if (props?.user?.server_status === 0) {
                            return (
                              <div
                                style={{
                                  display: "flex",
                                  width: "100%",
                                  height: "100vh",
                                  // background: '#255eaa',
                                  justifyContent: "center",
                                }}
                              >
                                <Result
                                  style={{ alignSelf: "center" }}
                                  icon={
                                    <SettingOutlined
                                      spin
                                      style={{ color: "black" }}
                                    />
                                  }
                                  title={
                                    <p
                                      style={{
                                        color: "black",
                                        textAlign: "center",
                                      }}
                                    >
                                      Emergency maintenance, Sorry for the
                                      inconvenience.!
                                      <br></br>
                                    </p>
                                  }
                                />
                              </div>
                            );
                          }
                          return (
                            <Wallet
                              {...props}
                              accounts={props?.user?.accounts}
                            />
                          );
                        }}
                      />
                      <Route
                        path={"/:lang/wallet/account/:type"}
                        render={(props) => {
                          if (props?.user?.server_status === 0) {
                            return (
                              <div
                                style={{
                                  display: "flex",
                                  width: "100%",
                                  height: "100vh",
                                  // background: '#255eaa',
                                  justifyContent: "center",
                                }}
                              >
                                <Result
                                  style={{ alignSelf: "center" }}
                                  icon={
                                    <SettingOutlined
                                      spin
                                      style={{ color: "black" }}
                                    />
                                  }
                                  title={
                                    <p
                                      style={{
                                        color: "black",
                                        textAlign: "center",
                                      }}
                                    >
                                      Emergency maintenance, Sorry for the
                                      inconvenience.!
                                      <br></br>
                                    </p>
                                  }
                                />
                              </div>
                            );
                          }
                          return (
                            <Wallet
                              {...props}
                              accounts={props?.user?.accounts}
                            />
                          );
                        }}
                      />
                      <Route path={"/:lang/wallet/fund"} component={Fund} />
                      <Route
                        path={"/:lang/wallet/compare"}
                        exact
                        component={Compare}
                      />
                      {/* <Route
                      path={"/:lang/wallet/economic"}
                      exact
                      component={Economic}
                    /> */}

                      <Route
                        path={"/:lang/wallet/lotback"}
                        exact
                        component={Lotback}
                      />
                      <Route
                        path={"/:lang/wallet/loyalty/1"}
                        exact
                        component={LoyaltyRissing}
                      />
                      <Route
                        path={"/:lang/wallet/receivebonus"}
                        exact
                        component={Bonus}

                        // component={Bonus}
                      />
                      <Route
                        path={"/:lang/wallet/chart"}
                        exact
                        component={Chart}
                      />

                      <Route
                        path={"/:lang/wallet/analytics"}
                        component={Analyze}
                      />
                      <Route
                        path={"/:lang/wallet/promotion"}
                        component={Promotion}
                      />
                      <Route
                        path={"/:lang/wallet/webinar"}
                        component={Webinar}
                      />
                      <Route
                        path={"/:lang/wallet/tradingsoftware"}
                        exact
                        component={TradeProgram}
                      />
                      <Route
                        path={"/:lang/wallet/tradingprogram"}
                        exact
                        component={TradeProgramIUX}
                      />
                      <Route
                        path={"/:lang/wallet/typeaccount"}
                        exact
                        component={AccountType}
                      />
                      <Route
                        path={"/:lang/wallet/setting"}
                        exact
                        component={PageSetting}
                      />
                      <Route
                        path="/:lang/wallet/verify-bookbank"
                        exact
                        component={VerifyBookBank}
                      />
                      <Route path="/:lang/wallet/contest" component={Contest} />
                      {/* <Route
                      path={"/:lang/wallet/contact"}
                      exact
                      render={(props) => (
                        <Contact locale={locale} user={props.user} {...props} />
                      )}
                    /> */}
                      {/* <Route path="/:lang/formpartner" component={FormPartner} /> */}
                      <Route
                        path="/:lang/wallet/formpartner"
                        component={FormPartner}
                      />
                      <Redirect
                        to={
                          props?.user?.accounts?.filter(
                            (e) => e.type === "welcome"
                          ).length > 0
                            ? `/:lang/wallet/account/welcome`
                            : `/:lang/wallet/account/Standard`
                        }
                      />
                      {/* <Redirect to="/:lang/wallet/account/Standard" /> */}
                    </Switch>
                  </div>
                  <footer
                    style={{ color: "#000", padding: 0, paddingTop: 48 }}
                    className="container m-auto mt-5"
                  >
                    <FooterAuthPage
                      locale={locale}
                      isDashboard={true}
                      location={location}
                      country_id={props?.user?.profile?.country_id}
                    />
                  </footer>
                </Content>
              </Layout>
              <CreateBonus
                isOpen={isOpenCreate}
                onCloseBonus={onChangeIsCreate}
              />
            </Layout>
          </Layout>
          {/* <ContactExpand /> */}
        </Layout>
      );
    } else {
      return (
        <div>
          <div
            style={{
              display: "flex",
              width: "100%",
              height: "100vh",
              background:
                'url("/assets/images/covers/background-maintance.jpg")',
              justifyContent: "center",
            }}
          >
            <Result
              style={{ alignSelf: "center" }}
              icon={<SettingOutlined spin style={{ color: "white" }} />}
              title={
                <p style={{ color: "white", textAlign: "center" }}>
                  Emergency maintenance, Sorry for the inconvenience.!
                  <br></br>
                </p>
              }
            />
          </div>
        </div>
      );
    }
  };

  return (
    <>
      <ConfigProvider
        theme={{
          hashed: false,
          token: {
            colorPrimary: "#1cb894",
            colorInfo: "#1cb894",
          },
        }}
        message={{ duration: 2.5 }}
      >
        <RcQueueAnim>
          {/* <Spin spinning={false} delay={500}> */}
          {renderMaintenance()}
          {/* </Spin> */}
          <ModalJumio isOpen={isOpenVerify} onClose={onCloseVerify} />
          <ModalCloseCampaign
            isOpen={isOpenModalCloseCampaign}
            onClose={onCloseCampaignClose}
          />
          <CreateAccount
            isOpen={isModalOpenAccount?.isOpen}
            onClose={onCloseModalOpenAccount}
            isType={"trade-real"}
            isAccountType={isModalOpenAccount?.account_type}
            isCoupon={isModalOpenAccount?.isCoupon}
          />
          <AlertOpenAccount />
          {/* <ModalCampaign isOpen={isModalCampaign} onClose={onCloseCampaign} /> */}
          {/* {!props?.user?.enabled_2fa && <Modal2fa />} */}
        </RcQueueAnim>
      </ConfigProvider>
    </>
  );
};

const mapStateToProps = ({ user, i18n }) => {
  return { user: user, locale: i18n.locale };
};

export default connect(mapStateToProps, {
  LogoutAuth,
  updateGetBonus,
  getArchive,
  getUser,
})(withRouter(Dashboard2));
